// import React, {useCallback} from 'react'
import React from 'react'
import {
  BooleanField,
  Datagrid,
  TextField,
  TextInput,
  // SearchInput,
  // useLocaleState,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, BLOGS_FIELDS } from '../../providers/localization/constant'

const RESOURCE_PREFIX = 'resources.blogs'

const BlogsList = (): JSX.Element => {
  // const [currentLocale] = useLocaleState()
  // const handleRowClick = useCallback(
  //   (id) => {
  //     return `${id}/show?lang=${currentLocale}`
  //   },
  //   [currentLocale],
  // )
  const translate = useTranslate()
  const BlogsListFilters = [
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${BLOGS_FIELDS}.title`)}
    />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.published.label`}
      source='is_published'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
        { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
      ]}
    />,
    // <SelectInput
    //       key={3}
    //       label={`${COMMON_FIELDS}.approved.label`}
    //       source='is_approved'
    //       choices={[
    //         { id: 'true', name: `${COMMON_FIELDS}.approved.choices.true` },
    //         { id: 'false', name: `${COMMON_FIELDS}.approved.choices.false` },
    //       ]}
    //     />,
    <SelectInput
      key={2}
      label={`${RESOURCE_PREFIX}.highlight.title`}
      source='is_highlight'
      choices={[
        { id: 'true', name: `${RESOURCE_PREFIX}.highlight.choices.true` },
        { id: 'false', name: `${RESOURCE_PREFIX}.highlight.choices.false` },
      ]}
    />,
    <SelectInput
      key={4}
      label={`${COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]

  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={BlogsListFilters}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='show'>
        <TextField source='title_th' label={`${BLOGS_FIELDS}.title_th`}></TextField>
        <TextField source='title_en' label={`${BLOGS_FIELDS}.title_en`}></TextField>
        {/* <TextField source='description_th' label={`${BLOGS_FIELDS}.description_th`} sortable={false}></TextField> */}
        {/* <TextField source='description_en' label={`${BLOGS_FIELDS}.description_en`} sortable={false}></TextField> */}
        <TextField
          source='short_description_th'
          label={`${BLOGS_FIELDS}.short_description_th`}
          sortable={false}
        ></TextField>
        <TextField
          source='short_description_en'
          label={`${BLOGS_FIELDS}.short_description_en`}
          sortable={false}
        ></TextField>
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <DateField source='start_date' label={`${BLOGS_FIELDS}.start.title`} textAlign='center' />
        <DateField source='end_date' label={`${BLOGS_FIELDS}.end.title`} textAlign='center' />
        <BooleanField
          source='is_highlight'
          label={`${RESOURCE_PREFIX}.highlight.title`}
          textAlign='center'
          sortable={false}
        />
        <BooleanField
          source='is_published'
          label={`${COMMON_FIELDS}.published.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default BlogsList
